import {
  List,
  TextField,
  FunctionField,
  SelectField,
  EditButton,
  ShowButton,
  SimpleList,
  Datagrid,
  CreateButton,
  TopToolbar,
} from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { MonthsOfTheYear } from "utils/choices";
import { getPermissions } from "auth/security/securityUtils";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { MoneyField } from "server/components/Fields/MoneyField";
import { healthInsuranceId, getMonthName } from "./utils";

const ListHealthInsurances = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return <TopToolbar>{hasCreate && <CreateButton />}</TopToolbar>;
  };

  return (
    <List
      title="Здравни осигуровки"
      sx={settings.style.expandStyle}
      actions={ListActions(checkPermission(userPermissions, permissions.canManageHealthInsurances))}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "От година", value: record.year }]} />
              <MobileListRow fields={[{ label: "От месец", value: getMonthName(record.month) }]} />
              <MobileListRow fields={[{ label: "Стойност", value: record.amount + " €" }]} />
              <MobileListRow fields={[{ label: "Процент", value: record.percentage + "%" }]} />
            </div>
          )}
          tertiaryText={record => (
            <>
              <SecuredComponent permission={permissions.canManageHealthInsurances}>
                <EditButton record={{ id: healthInsuranceId(record) }} />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewHealthInsurances}>
                <ShowButton record={{ id: healthInsuranceId(record) }} />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={{
            "& .column-year": { textAlign: "center" },
            "& .column-month": { textAlign: "center" },
            "& .column-amount": { textAlign: "center" },
            "& .column-percentage": { textAlign: "center" },
            "& .column-actions": { textAlign: "center" },
          }}
        >
          <TextField
            source="year"
            label="От година"
            sortable={false}
          />
          <SelectField
            source="month"
            label="От месец"
            choices={MonthsOfTheYear}
            sortable={false}
          />
          <MoneyField
            source="amount"
            label="Стойност"
            sortable={false}
          />
          <FunctionField
            source="percentage"
            label="Процент"
            sortable={false}
            render={record => record.percentage + "%"}
          />
          <FunctionField
            source="actions"
            label=""
            sortable={false}
            render={record => (
              <SecuredComponent permission={permissions.canManageHealthInsurances}>
                <EditButton record={{ id: healthInsuranceId(record) }} />
              </SecuredComponent>
            )}
          />
          <FunctionField
            label=""
            source="actions"
            sortable={false}
            render={record => (
              <SecuredComponent permission={permissions.canPreviewHealthInsurances}>
                <ShowButton record={{ id: healthInsuranceId(record) }} />
              </SecuredComponent>
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};
export default ListHealthInsurances;
